import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import { useAuthStore } from './stores/auth'

import App from './App.vue'
import './styles/index.css'

const app = createApp(App)

app.use(createPinia())

// Inicializar autenticação antes do router
const authStore = useAuthStore()
authStore.initAuth()

app.use(router)

app.mount('#app')
